@if (ui<2) {
  @if (extNewFolder) {
    <otc-input id="folder-name" required="true"
      type="text" class="ext-folder-name"
      [ariaLabel]="this.localizer.getTranslation('FORMS.LOCAL.CORE.NAME')"
      [title]="this.localizer.getTranslation('FORMS.LOCAL.CORE.NAME')"
      [label]="this.localizer.getTranslation('FORMS.LOCAL.CORE.NAME')"
      livevalidation=""
      (change)="onValueChange($event)"
      max="200" maxlength="100"
      [placeholder]="this.localizer.getTranslation('FORMS.PLACEHOLDERS.TEXT')"
      autocomplete="off">
    </otc-input>
  }
  <div class="search-collaborator-wrapper">
    <div class="select-comment-wrapper">
      <otc-select id="search-collaborator" #userSearch
        [placeholder]="this.localizer.getTranslation('FORMS.LOCAL.CORE.ENTER_COLLABORATORS')"
        (keyup)="onKeyupSearch($event)"
        (change)="onChangeSearch($event)"
        autocomplete="off">
      </otc-select>
      <otc-textarea id="comment-collaborator" #userComment
        name="comment" rows="3"
        [placeholder]="this.localizer.getTranslation('FORMS.LOCAL.CORE.MESSAGE')"
        [title]="this.localizer.getTranslation('FORMS.LOCAL.CORE.MESSAGE')"
        [ariaLabel]="this.localizer.getTranslation('FORMS.LOCAL.CORE.MESSAGE')">
      </otc-textarea>
    </div>
    <otc-button id="add-collaborator" type="secondary" disabled="" (click)="addUser()">Add</otc-button>
  </div>
  <edx-action-bar [menuID]="actionMenuId" [target]="this" #actionbar></edx-action-bar>
  <div class="list" [ngClass]="{disablelist:isReadOnly}">
    <edx-list-table #table
      [schemaId]="'SECURITY_EXTERNAL'"
      [desc]="desc"
      [params]="'collaborators'"
      (listItemChangeNotify)='onTemplateRightChange($event)'
      [inlineActionMenuId]="6"
      [inlineActionTarget]="this"
      [parent]="this"
      [disableSecurity]="isReadOnly">
    </edx-list-table>
  </div>
}